// extracted by mini-css-extract-plugin
module.exports = {"btn":"go-back_btn__1oMeF"};